import "./counterloading.css";
import React from "react";
function CounterLoading() {
  return (
    <div className="counter-loading">
      <h1>Cargando Tareas</h1>
    </div>
  );
}
export { CounterLoading };



// WEBPACK FOOTER //
// ./src/counterloading/counterloading.js